<template>
  <v-img :src="img"></v-img>
</template>

<script>
export default {
  props: {
    isHovered: {
      type: Boolean,
      default: false,
    },
    collapsedDrawer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      img: require("@/assets/RideryFlyLight.svg")
    }
  }
};
</script>

<style scoped>
/* Add scoped styles if needed */
</style>
